import React, { useEffect, useState } from 'react';
import axios from 'axios';

interface LogEntry {
  id: number;
  machine_url: string;
  type_log: string;
  file_name: string;
  created_date: string;
}

interface GroupedLogs {
  [key: string]: LogEntry[];
}

const LogListView: React.FC = () => {
  const [logs, setLogs] = useState<GroupedLogs>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [expandedFolders, setExpandedFolders] = useState<Set<string>>(
    new Set()
  );

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const response = await axios.get<LogEntry[]>('/api/logs/');
        const logsData = response.data;

        // Group logs by type_log
        const groupedLogs = logsData.reduce<GroupedLogs>((acc, log) => {
          const folder = log.type_log;
          if (!acc[folder]) {
            acc[folder] = [];
          }
          acc[folder].push(log);
          return acc;
        }, {});

        setLogs(groupedLogs);
      } catch (error) {
        console.error('Error fetching logs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, []);

  const handleFileDownload = (logId: number) => {
    // Trigger the file download
    window.location.href = `/api/logs/request/${logId}/`;
  };
  const toggleFolder = (folder: string) => {
    setExpandedFolders((prev) => {
      const newExpandedFolders = new Set(prev);
      if (newExpandedFolders.has(folder)) {
        newExpandedFolders.delete(folder); // Collapse the folder
      } else {
        newExpandedFolders.add(folder); // Expand the folder
      }
      return newExpandedFolders;
    });
  };

  if (loading) {
    return <div>Loading...</div>;
  }
  return (
    <div>
      <h2>Log Files</h2>
      {Object.keys(logs).map((folder) => (
        <div key={folder}>
          <h4
            onClick={() => toggleFolder(folder)}
            style={{ cursor: 'pointer' }}
          >
            📁 {folder} {expandedFolders.has(folder) ? '▼' : '►'}
          </h4>
          {expandedFolders.has(folder) && (
            <ul>
              {logs[folder].map((log) => (
                <li key={log.id}>
                  <button onClick={() => handleFileDownload(log.id)}>
                    📄 {log.file_name}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default LogListView;
